import React from 'react';

import PropTypes from 'prop-types';

import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';

const SubscriptionPausedPopup = (props) => {
    return (
        <SimplePopup text={props.text} popupRef={props.popupRef}>
            <PopupButton
                iconName="check"
                text={props.gotIt}
                onClick={() => {
                    props.popupRef?.current?.close();
                }}
            />
        </SimplePopup>
    );
};
SubscriptionPausedPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    text: PropTypes.string,
    gotIt: PropTypes.string,
};
export default SubscriptionPausedPopup;
